import React from "react";
import { getChildrenOfType, useFeatureFlag } from "@qualio/ui-components";
import { FeatureFlags } from "@design-controls/types";

type FeatureFlagProps = {
  feature: FeatureFlags;
};

export const EnabledFeatureFlag: React.FC = ({ children }) => <>{children}</>;
EnabledFeatureFlag.displayName = "EnabledFeatureFlag";

export const DisabledFeatureFlag: React.FC = ({ children }) => <>{children}</>;
DisabledFeatureFlag.displayName = "DisabledFeatureFlag";

export const FeatureToggle: React.FC<FeatureFlagProps> = ({
  children,
  feature,
}) => {
  const features = useFeatureFlag();

  return (
    <>
      {getChildrenOfType(
        children,
        features[feature] ? "EnabledFeatureFlag" : "DisabledFeatureFlag",
      )}
    </>
  );
};
